import getInstancesFromDomainMapReduxUtil from 'modules/redux/utils/legacy/get-instances-from-domain-map'
import { performSearchUtil } from 'utils/search/perform/index.js'

/**
 * Searches and orders items matching the given query.
 * @param  {Object} params
 *         {Object} params.domain
 *         {string} params.section
 *         {string} params.query
 *         {string} [params.category]
 * @returns {Object[]}
 */
function searchItemsSectionUtil (params) {
  const {
    domain,
    category,
    section,
    query,
    isExact,
    domainList
  } = params

  // - If the query is too small, no-op
  // - If a `category` is provided, the `section` in that case should be matching
  // the `category`
  if ((category && category !== section)) {
    return []
  }

  // Lowercase the query
  const queryString = query.toLowerCase()

  // Get the item objects
  const items = getInstancesFromDomainMapReduxUtil(
    domain?.data,
    domainList?.data
  )

  if (!query.length) {
    return items
  }

  const searchParams = isExact ? { threshold: 0.3 } : {}
  const searchedItems = performSearchUtil(items, queryString, searchParams)
  // Retrieve the ordered items
  return searchedItems.map(searchItem => searchItem.item)
}

export {
  searchItemsSectionUtil
}
